@let row = params.data;
@let password = getVideoPassword(0);
@let link = getVideoLink(0);
@let photoUrl = photoLink();

@if (row.video_links?.[0]) {
  <div class="relative flex justify-center items-center">
    @if (photoUrl) {
      <img
        class="w-12 h-12 rounded-md object-cover ml-auto mr-auto opacity-50"
        data-testid="case_tracking_video_button"
        appTrackReviewActivity
        [appTrackReviewActivity]="row.review_id"
        [appTrackReviewActivityAccessType]="accessType"
        [appTrackReviewActivityValue]="'video'"
        [src]="photoUrl"
        (click)="videoModal.show(); loadVideos()"
      />
    } @else {
      <div class="w-12 h-12 rounded-md object-cover ml-auto mr-auto opacity-50 flex justify-center items-center">
        <app-pan-spinner size="lg"></app-pan-spinner>
      </div>
    }
    <mat-icon class="absolute pointer-events-none">play_circle</mat-icon>
  </div>

  <app-pan-modal #videoModal (modalWillOpen)="currentVideo.set(0)">
    <div header>Case {{ row.case_num }}, Instance {{ row.instance_num }}</div>

    <div body class="flex items-center justify-center">
      @for (video of row.video_links; track $index) {
        @if (loadingVideosForReport() && currentVideo() === $index) {
          <app-pan-video
            class="w-full max-w-[640px]"
            [src]="video"
            data-testid="case-tracking-incident-video"
          ></app-pan-video>
        }
      }
    </div>

    <div footer class="flex w-full justify-end" [class.justify-between]="row.video_links.length > 1">
      @if (row.video_links.length > 1) {
        <div class="flex justify-between items-center w-1/2">
          <app-pan-button icon="chevron_left" (click)="prevVideo()" [disabled]="currentVideo() <= 0"></app-pan-button>

          Video {{ currentVideo() + 1 }} of {{ row.video_links.length }}

          <app-pan-button
            icon="chevron_right"
            (click)="nextVideo()"
            [disabled]="currentVideo() >= row.video_links.length - 1"
          ></app-pan-button>
        </div>
      }
      <app-pan-button panModalClose>Close</app-pan-button>
    </div>
  </app-pan-modal>
} @else if (link.length > 0 && password) {
  <div class="relative flex justify-center items-center">
    <img
      class="w-12 h-12 rounded-md object-cover ml-auto mr-auto opacity-50"
      data-testid="case_tracking_video_button"
      appTrackReviewActivity
      [appTrackReviewActivity]="row.review_id"
      [appTrackReviewActivityAccessType]="accessType"
      [appTrackReviewActivityValue]="'video'"
      [src]="photoUrl"
      (click)="videoLinkModal.show(); loadVideos()"
    />
    <mat-icon class="absolute pointer-events-none">play_circle</mat-icon>
  </div>

  <app-pan-modal #videoLinkModal>
    <div header>Case {{ row.case_num }}, Instance {{ row.instance_num }}</div>

    <div body class="text-left">
      @if (password) {
        <div class="mt-1">
          Click here to copy the password: <a panButton size="sm" (click)="copyToClipboard($event, password)">{{ password }}</a>
        </div>
      }

      <div class="mt-1">
        Click here to navigate to the video recording:
        <a panButton icon="open_in_new" size="sm" [href]="link" target="_blank" panModalClose></a>
      </div>
    </div>

    <div footer>
      <app-pan-button panModalClose>Close</app-pan-button>
    </div>
  </app-pan-modal>
} @else if (link.length > 1 && !password) {
  <div class="relative flex justify-center items-center">
    <a [href]="link" target="_blank">
      <img
        class="w-12 h-12 rounded-md object-cover ml-auto mr-auto opacity-50"
        data-testid="case_tracking_video_button"
        appTrackReviewActivity
        [appTrackReviewActivity]="row.review_id"
        [appTrackReviewActivityAccessType]="accessType"
        [appTrackReviewActivityValue]="'video'"
        [src]="photoUrl"
      />
    </a>
    <mat-icon class="absolute pointer-events-none">play_circle</mat-icon>
  </div>
}
